// extracted by mini-css-extract-plugin
export var closeButton = "cookie-consent-module--closeButton--888d6";
export var cookieConsent = "cookie-consent-module--cookieConsent--23a8a";